const currency = new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
})

export const formatPrice = (value: number): string => {
    return currency.format(value)
}
